<template>
	<div :class="modalMode ? 'details-in-modal mapping-modal' : 'pt-3 pl-5 pr-5'">
		<div class="mb-2" v-if="!modalMode">
			<breadCrumb :routesArray="routesArray"></breadCrumb>
		</div>
		<div class="flex flex-col flex-1 min-h-0 overflow-hidden">
			<div class="items-center justify-between flex flex-shrink-0">
				<div class="title flex items-center" v-if="!modalMode">
					<h1 class="title" :class="titleLength > 40? 'heading-ellipsis':''">{{presentControlObject.controlTitle}}</h1>
				</div>
				<div v-else></div>
				<div class="flex flex-row-reverse gap-3">
					<button class="flex" @click="filterOpen" :class="(selectedTabIndex == 0 && kpisListForPresentControl.length != 0) || (selectedTabIndex == 1 && allRootKpis.length != 0) ? 'filterButton' : 'filterButtondisabled pointer-events-none'">
						<img v-if="(selectedTabIndex == 0 && kpisListForPresentControl.length != 0) || (selectedTabIndex == 1 && allRootKpis.length != 0)" src="@/assets/filter.svg" class="filterIcon" />
						<img v-else src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/>
						Filters
					</button>
					<button v-if="selectedTabIndex == 0" :class="showTotalKpisWeightage < 100 && !onSelectCheckBox ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="addKPI(kpi)">Add</button>
				</div>
			</div>
			<div class="mt-5 card w-full h-full flex flex-col min-h-0 mapping-tabs-shell flex-1">
				<div class="px-5 pb-3 flex-1 min-h-0 flex flex-col">
					<Tabs v-model:value="selectedTabIndex">
                    <div class="pt-5">
						<TabList>
							<Tab v-for="(tab) in carouselHead" :key="tab.id" :value="tab.id" @click="toggleTabs(tab.id)">
								{{ tab.displayName }}
							</Tab>
						</TabList>
					</div>
                    <TabPanels class="mt-5">
                        <TabPanel v-for="(tab) in carouselHead" :key="tab.id" :value="tab.id">
							<div class="flex flex-col flex-1 min-h-0 overflow-hidden">
								<div v-if="tab.id == 0" class="noScrollbar tabStructure1 mapping-tab-pane kpi-table-pane">
								<div class="ResponsivetableCornerRadius bg-white table-container kpi-table-scroll">
									<!-- :class="sortedAppliedKpisData.length == 0 ? 'border-separate' : 'border-collapse'" -->
									<table class="main-table">
										<thead>
												<tr class="table-header-row">
												<th class="w-12 bg-white">
													<input type="checkbox" name="checkbox" class="checkbox cursor-pointer" v-model="selecteAllActiveKpis" @change="deSelectKpis(0,$event)" :disabled="sortedAppliedKpisData.length==0"/>
												</th>
												<th scope="col" v-for="column in tableHeads" :key="column" class="bg-white cursor-pointer capitalize" :class="getColumnHeadWidth(column)" @click="sort(column)">
													<div>
														<div class="flex" :class="widthOfColumns(column)">
															<div v-if="column == 'description'">KPI Name</div>
															<div v-else-if="column == 'weightage'">weightage (%)</div>
															<div v-else-if="column == 'target'">target</div>
															<div v-else-if="column == 'targetType'">Target Type</div>
															<div v-else-if="column == 'kpiCondition'">Condition</div>
															<div v-else-if="column == 'kpiType'">Type</div>
															<div v-else>{{column}}</div>
															<div class="sort cursor-pointer" :class="className == column && (selectedTabIndex == 0 && kpisListForPresentControl.length != 0) || (selectedTabIndex == 1 && allRootKpis.length != 0) ? classSort : 'opacity-50'"></div>
														</div>
													</div>
												</th>
												</tr>
											<!-- </tr> -->
											<tr v-if="showFilters" class="table-filter-row">
												<td></td>	
												<td v-for="name in tableHeads" class="bg-white" :key="name">
													<select class="inputboxstyling resize" v-if="name == 'targetTimePeriod' || name == 'reportingFrequency'" v-model="filters[name]">
														<option :value="filters.name" selected disabled hidden>Select</option>
														<option v-for="(value, index) in controlRecurringArray" :key="index" :value="value.id">{{ value.label }}</option>
													</select>
													<select class="inputboxstyling resize" v-if="name == 'kpiType'" v-model="filters[name]" :class="filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'">
														<option :value="filters.name" selected disabled hidden>Select</option>
														<option v-for="(value, index) in kpiTypeOptions" :key="index" :value="value.id">{{ value.name }}</option>
													</select>
													<div v-else-if="name == 'weightage' || name == 'target' || name == 'targetType' || name == 'kpiCondition'"></div>
													<input v-else type="text" class="searchForInputBoxStyling" placeholder="Search" v-model="filters[name]" />
												</td>
											</tr>
										</thead>
										<tbody v-if="loadData == true">
											<tr class="cursor-pointer empty rowHeight">
												<td class="relative h-5" :colspan="tableHeads.size">
													<div class="flex items-center justify-center w-full h-16 skeleton">
														<dots-loader/>
													</div>
												</td>
											</tr>
										</tbody>
										<tbody v-else-if="columnObject || sortedAppliedKpisData.length === 0">
											<tr class="cursor-pointer rowHeight">
												<td class="relative h-10" :colspan="tableHeads.length">
													<div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
												</td>
											</tr>
										</tbody>
										<tbody v-else class="tbodylast">
											<tr v-for="(kpiData, index) in sortedAppliedKpisData" :key="kpiData._id" :class="index % 2 == 0 ? 'odd' : 'even'">
												<td>
													<input type="checkbox" name="checkbox" class="checkbox cursor-pointer" v-model="checkedActiveKpis"  @change="changedActiveKpiInput(0, $event, kpiData.weightage)" :value="kpiData._id" />
												</td>
												<td v-for="column in tableHeads" :key="column" @mouseout="doFalse()" @click="showEditPopUp(kpiData)" class="whitespace-nowrap cursor-pointer relative">
													
													<div v-if="column == 'targetTimePeriod' || column == 'reportingFrequency'">
														<div class="overflow-hidden table-ellipsis">
															<div class="inline">
																{{
																	controlRecurringArray.find((itemOne) => {
																		return itemOne.id == kpiData[column];
																	}).label
																}}
															</div>
														</div>
													</div>
													<div v-else-if="column == 'kpiType'">
														<div v-if="kpiData.kpiType == 3">Custom</div>
														<div v-else-if="kpiData.kpiType == 2">Optional</div>
														<div v-else>N/A</div>
													</div>
													<div v-else-if="column == 'weightage'">
														<div class="pl-6">{{ kpiData[column] }}</div>
													</div>
													<div v-else-if="column == 'target'">
														<div class="pl-6">{{ formatKpiTargetForDisplay(kpiData) }}</div>
													</div>
													<div v-else-if="column == 'targetType'">
														<div class="pl-6">{{ getTargetTypeLabel(kpiData.targetType) }}</div>
													</div>
													<div v-else-if="column == 'kpiCondition'">
														<div class="pl-6">{{ getKpiConditionLabel(kpiData.kpiCondition || kpiData.targetOperator || kpiData.logic) }}</div>
													</div>
													<div v-else>
														<div class="overflow-hidden table-ellipsis">
															<div class="inline">
																{{ kpiData[column] }}
															</div>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
									<div v-if="sortedAppliedKpisData.length != 0">
										<pagination :dynamicPagination="dynamicPagination" @currentPageUpdate="paginationUpdations" :sortedData="sortedAppliedKpisData"></pagination>
									</div>
								</div>
								</div>
								<div v-if="tab.id == 1" class="noScrollbar tabStructure1 mapping-tab-pane kpi-table-pane">
								<div class="ResponsivetableCornerRadius bg-white table-container kpi-table-scroll">
									<table class="main-table">
										<thead>
											<tr class="table-header-row">
											<th class="" v-if="allRootKpis.length != 0">
												<input type="checkbox" name="checkbox" class="checkbox cursor-pointer" v-model="selecteAllRelatedKpis" @change="selectKpis(1,$event)" />
											</th>
											<th scope="col" v-for="column in tableHeads" :key="column" class="bg-white cursor-pointer capitalize" @click="sort(column)" :class="getColumnHeadWidth(column)">
												
												<div>
													<div class="flex" :class="widthOfColumns(column)">
														<div v-if="column == 'description'">KPI Name</div>
														<div v-else-if="column == 'weightage'">weightage (%)</div>
														<div v-else-if="column == 'target'">target</div>
														<div v-else-if="column == 'targetType'">Target Type</div>
														<div v-else-if="column == 'kpiCondition'">Condition</div>
														<div v-else>{{column}}</div>
														<div class="sort cursor-pointer" :class="className == column && (selectedTabIndex == 0 && kpisListForPresentControl.length != 0) || (selectedTabIndex == 1 && allRootKpis.length != 0) ? classSort : 'opacity-50'"></div>
													</div>
												</div>
											</th>
											</tr>
											<tr v-if="showFilters" class="table-filter-row">
												<td v-if="allRootKpis.length != 0"></td>
												<td v-for="name in tableHeads" class="bg-white" :key="name">
													<select class="inputboxstyling resize" v-if="name == 'targetTimePeriod' || name == 'reportingFrequency'" v-model="filters[name]">
														<option :value="filters.name" selected disabled hidden>Select</option>
														<option v-for="(value, index) in controlRecurringArray" :key="index" :value="value.id">{{ value.label }}</option>
													</select>
													<select class="inputboxstyling resize" v-if="name == 'kpiType'" v-model="filters[name]"  :class="filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'">
														<option :value="filters.name" selected disabled hidden>Select</option>
														<option v-for="(value, index) in kpiTypeOptions" :key="index" :value="value.id">{{ value.name }}</option>
													</select>
													<div v-else-if="name == 'weightage' || name == 'target' || name == 'targetType' || name == 'kpiCondition'"></div>
													<input v-else type="text" class="searchForInputBoxStyling" placeholder="Search" v-model="filters[name]" />
												</td>
											</tr>
										</thead>
										<tbody v-if="loadData == true">
											<tr class="cursor-pointer empty rowHeight">
												<td class="flex items-center justify-center relative h-5" :colspan="tableHeads.size">
													<div class="flex items-center justify-center w-full h-16 skeleton">
														<dots-loader/>
													</div>
												</td>
											</tr>
										</tbody>
										<tbody v-else-if="columnObject || sortedData.length === 0">
											<tr class="cursor-pointer rowHeight">
												<td class="relative h-10" :colspan="tableHeads.length">
													<div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
												</td>
											</tr>
										</tbody>
										<tbody v-else class="tbodylast">
											<tr v-for="(kpiData, index) in sortedData" :key="kpiData._id" :class="index % 2 == 0 ? 'odd' : 'even'">
												<td>
													<div class="flex items-center">
														<input type="checkbox" name="checkbox" class="checkbox cursor-pointer" :value="kpiData" v-model="selectedRootKpis" @change="calculateWeightAge(1, $event, kpiData.weightage)" />
													</div>
												</td>
												<td v-for="column in tableHeads" :key="column" @mouseout="doFalse()" class="whitespace-nowrap cursor-pointer relative">
													<div v-if="column == 'targetTimePeriod' || column == 'reportingFrequency'">
														<div class="overflow-hidden table-ellipsis">
															<div class="inline">
																{{
																	controlRecurringArray.find((itemOne) => {
																		return itemOne.id == kpiData[column];
																	}).label
																}}
															</div>
														</div>
													</div>
													<div v-else-if="column == 'weightage'">
														<div class="pl-6">{{ kpiData[column] }}</div>
													</div>
													<div v-else-if="column == 'target'">
														<div class="pl-6">{{ formatKpiTargetForDisplay(kpiData) }}</div>
													</div>
													<div v-else-if="column == 'targetType'">
														<div class="pl-6">{{ getTargetTypeLabel(kpiData.targetType) }}</div>
													</div>
													<div v-else-if="column == 'kpiCondition'">
														<div class="pl-6">{{ getKpiConditionLabel(kpiData.kpiCondition || kpiData.targetOperator || kpiData.logic) }}</div>
													</div>
													<div v-else>
														<div class="overflow-hidden table-ellipsis">
															<div class="inline">
																{{ kpiData[column] }}
															</div>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
									<div v-if="sortedData.length != 0">
										<pagination :dynamicPagination="dynamicPagination" @currentPageUpdate="paginationUpdations" :sortedData="sortedData" v-if="!columnObject"></pagination>
									</div>
								</div>
								</div>
							</div>
						</TabPanel>
					</TabPanels>
					</Tabs>	

				</div>
				<div class="flex-shrink-0">
					<div v-if="selectedTabIndex == 0" class="card-footer-actions bottom-7 bg-white h-14 flex justify-between items-center w-full rounded-b-sm" style="box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);">
					<div class="flex items-center text-sm ml-5">
						Total Weightage is: {{ showTotalKpisWeightage }} %
					</div>	
					    <div class="flex items-center px-5 mx-5">
						<button class="mr-2"  :class="arraysAreEqual ? 'btndisabled pointer-events-none' : 'btnprimary'" @click="cancelActiveKpis()">Cancel</button>
						<button :class="arraysAreEqual ? 'btndisabled pointer-events-none' : 'btnprimary'" :disabled="isButtonDisabled" @click="saveToRelatedKpis(checkedActiveKpis,10303)">Save</button>
						</div>
					</div>
					<div v-if="selectedTabIndex == 1" class="card-footer-actions bottom-7 bg-white h-14 flex justify-between items-center w-full rounded-b-sm" style="box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);">
						<div class="flex items-center text-sm ml-5">
							Total Weightage is: {{ showTotalKpisWeightage }} %
						</div>
					<div class="flex items-center px-5 mx-5">
						<button class="mr-2" :class="selectedRootKpis.length > 0 ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="cancelRelatedKpis()">Cancel</button>
						<button @click="saveToRelatedKpis(selectedRootKpis,10301)" :disabled="isButtonDisabled" :class="selectedRootKpis.length > 0 ? 'btnprimary' : 'btndisabled pointer-events-none'">Save</button>
					</div>
					</div>
				</div>

 			</div>
			<popup v-if="showPopup" :popUp="showPopup">
				<template v-slot:header>
					<div class="flex items-center justify-between py-4 px-2 rounded">
						<h1 class="pl-2">Manage KPI</h1>
						<button
							class="float-right text-3xl"
							@click="
								onCancelbtn();
								showPopup = false;
							"
						>
							<img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
						</button>
					</div>
				</template>
		<div class="flex flex-col h-full">
			<div class="flex-1 overflow-auto">
				<fieldset>
					<div>
						<div>
							<div class="statuscontainer popupbodycontainer">
								<div class="formcontainer flex flex-col">
									<!-- <div class="row flex flex-row w-full upperspacing">
										<div class="w-full">
											<label class="controllabel">KPI ID</label>
											<input
												type="text"
												class="inputboxstyling"
												v-model="addingKpiObj.kpi_id"
												placeholder="KPI ID"
												disabled
												
											/>
											
										</div>
									</div> -->
									<div class="row flex flex-row w-full upperspacing">
										<div class="w-full">
											<label class="controllabel">KPI Name</label>
											<textarea
												type="text"
												class="inputboxstyling h-20 max-h-48"
												v-model.trim="addingKpiObj.description"
												@input="v$.addingKpiObj.description.$touch()" 
												placeholder="KPI Name"
												:class="{
													'is-invalid': v$.addingKpiObj.description.$error || isDuplicateData.description
												}"
											></textarea>
											<div v-if="v$.addingKpiObj.description.$error" class="text-red-500">
												<div class="error-text" v-if="v$.addingKpiObj.description.required.$invalid">Required</div>
												<div v-else-if="v$.addingKpiObj.description.required && v$.addingKpiObj.description.restrictCharacters100.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
											</div>
											<div v-if="isDuplicateData.description" class="text-red-500">
												<div class="error-text text-xs">KPI Name already exists.</div>
											</div>
										</div>
									</div>
						
									<div class="row flex flex-row w-full upperspacing gap-3">
										<div class="w-6/12">
											<label class="controllabel">Target Type</label>
											<Select
												v-model="addingKpiObj.targetType"
												:options="targetTypeOptions"
												optionLabel="label"
												optionValue="value"
												placeholder="Please select the option"
												class="w-full custom-multiselect userSelect mt-2 kpi-operator-select"
												:class="{ 'is-invalid': v$.addingKpiObj.targetType.$error }"
												@change="targetGreaterThanZero(addingKpiObj.target)"
											/>
											<div v-if="v$.addingKpiObj.targetType.$error" class="text-red-500">
												<div class="error-text" v-if="v$.addingKpiObj.targetType.required.$invalid">Required</div>
											</div>
										</div>
										<div class="w-6/12">
											<label class="controllabel">Condition</label>
											<Select
												v-model="addingKpiObj.kpiCondition"
												:options="kpiConditionOptions"
												optionLabel="label"
												optionValue="value"
												placeholder="Please select the option"
												class="w-full custom-multiselect userSelect mt-2 kpi-operator-select"
												:class="{ 'is-invalid': v$.addingKpiObj.kpiCondition.$error }"
											/>
											<div v-if="v$.addingKpiObj.kpiCondition.$error" class="text-red-500">
												<div class="error-text" v-if="v$.addingKpiObj.kpiCondition.required.$invalid">Required</div>
											</div>
										</div>
									</div>
									<div class="row flex flex-row w-full upperspacing gap-3">
										<div class="w-6/12">
											<label class="controllabel">{{ addingKpiObj.targetType === 'number' ? 'Target' : 'Target(%)' }}</label>
											<input
												type="number"
												class="inputboxstyling mt-2"
												v-model.trim="addingKpiObj.target"
												:maxlength="addingKpiObj.targetType === 'number' ? 10 : 3"
												ref="editTarget"
												:placeholder="addingKpiObj.targetType === 'number' ? 'Target' : 'Target (%)'"
												@keyup="targetLessThanZero(addingKpiObj.target); targetGreaterThanZero(addingKpiObj.target); handleTargetInput"
												:class="{
													'is-invalid': v$.addingKpiObj.target.$error || validTargetError || targetNumberLessThanZero,
												}"
											/>
											<div v-if="v$.addingKpiObj.target.$error || validTargetError || targetNumberLessThanZero" class="text-red-500">
												<div class="error-text" v-if="v$.addingKpiObj.target.required.$invalid">
													{{ addingKpiObj.targetType === 'number' ? 'Target is required' : 'Target (%) is required' }}
												</div>
												<div class="error-text" v-if="(validTargetError && !v$.addingKpiObj.target.required.$invalid) || (targetNumberLessThanZero == true && !v$.addingKpiObj.target.required.$invalid)">
													{{ addingKpiObj.targetType === 'number' ? 'Target is Invalid' : 'Target(%) is Invalid' }}
												</div>
											</div>
										</div>
										<div class="w-6/12">
											<label class="controllabel">Weightage (%)</label>
											<input
												type="number"
												class="inputboxstyling mt-2"
												v-model.trim="addingKpiObj.weightage"
												maxlength="3"
												ref="editWeight"
												placeholder="Weightage (%)"
												@keyup="weightageLessThanZero(addingKpiObj.weightage) || weightageGreaterThanZero(addingKpiObj) && handleInput"
												:class="{
												'is-invalid': v$.addingKpiObj.weightage.$error || validtaionWeightageError || numberLessThanZero,
												}"
											/>
											<div v-if="v$.addingKpiObj.weightage.$error || validtaionWeightageError || numberLessThanZero" class="text-red-500">
												<div class="error-text" v-if="v$.addingKpiObj.weightage.required.$invalid">
													Weightage (%) is required
												</div>
												<div class="error-text" v-if="(validtaionWeightageError && !v$.addingKpiObj.weightage.required.$invalid) || (numberLessThanZero == true && !v$.addingKpiObj.weightage.required.$invalid)">
													Weightage(%) is Invalid
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</fieldset>
			</div>
			<div>
				<div class="border-b border-solid border-lightgrey mx-5"></div>
					<div v-if="addingKpiObj._id" class="buttonposition flex justify-end items-center  pb-4 pl-5 pt-4 pr-5">
						<button class="mr-1.5" :class="disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="onCancelbtn()">Cancel</button>
						<button :class="disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="addOrUpdateKpiForControlManual(addingKpiObj)">Save</button>
					</div>
					<div v-else class="buttonposition flex justify-end items-center  pb-4 pl-5 pt-4 pr-5">
						<!-- <button class="mr-3" :class="addingKpiObj.metrics.length >= 2 ? 'btndisabled pointer-events-none' : 'btnprimary'" @click="addMetrics(addingKpiObj)">Add Metrics</button> -->
						<button class="mr-1.5" :class="disableStatus ? 'btndisabled pointer-events-none' : 'btnprimary'" @click="onCancelbtn()">Cancel</button>
						<button :class="disableStatus ? 'btndisabled pointer-events-none' : 'btnprimary'" @click="addOrUpdateKpiForControlManual(addingKpiObj)">Save</button>
					</div>
					</div>
				</div>
			</popup>
		</div>
	</div>
</template>
<style scoped>
.Vue-Toastification__container {
	z-index: 999999999 !important;
}
.kpi-table-pane {
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
	overflow: hidden;
}
.kpi-table-scroll {
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	max-height: 100%;
}
.table-container {
	overflow-y: auto;
	min-height: 0;
}
.main-table thead th {
	position: sticky;
	top: 0;
	z-index: 2;
	background: #ffffff;
}
  @media only screen and (min-width: 801px) and  (max-width: 1024px) {
    .tabStructure1 {
      height: calc(100vh - 340px);
    }
  }
  @media only screen and (min-width: 200px) and  (max-width: 800px) {
    .tabStructure1 {
      height: calc(100vh - 340px);
    }
  }
  @media only screen and (min-width: 1025px) and  (max-width: 1200px) {
    .tabStructure1 {
      height: calc(100vh - 340px);
    }
  }
  @media only screen and (min-width: 1201px) and  (max-width: 1400px) {
    .tabStructure1 {
      height: calc(100vh - 340px);
    }
  }
  @media only screen and (min-width: 1401px) and  (max-width: 1600px) {
    .tabStructure1 {
      height: calc(100vh - 340px);
    }
  }
  @media only screen and (min-width: 1601px) and  (max-width: 6000px) {
    .tabStructure1 {
      height: calc(100vh - 341px);
    }
  }
.anime-left {
	animation-name: moveLeft;
	animation-duration: 1s;
	animation-iteration-count: 1;
	animation-fill-mode: backwards;
}
@keyframes moveLeft {
	0% {
		opacity: 1;
		transform: translateX(100vw);
	}
	100% {
		transform: translateX(0);
	}
}
.anime-right {
	animation-name: moveRight;
	animation-duration: 1s;
	animation-iteration-count: 1;
	animation-fill-mode: backwards;
}
@keyframes moveRight {
	0% {
		opacity: 1;
		transform: translateX(-100vw);
	}
	100% {
		transform: translateX(0);
	}
}
.progressbarSI {
	border: 2px solid #e9e9e9;
	background: #e9e9e9;
	position: relative;
	top: -8px;
	border-radius:16px;
}
.progress {
	border-radius:16px;
    background: #1976d2;
}
.tbodylast:last-child {
	border-bottom: 1px solid #e9e9e9;
}
.ResponsivetableCornerRadius{
	/* margin-top/: 20px; */
    border:1px solid #e9e9e9;
    border-radius: 4px !important;
    padding: 1px;
}
thead tr {
  border-top: none !important;
}
@media only screen and (max-width: 768px) {
  .ResponsivetableCornerRadius
  {
    margin-left:0px !important;
  }
}
.button-adjust {
	position: relative;
	top: -30px;
	z-index: 1;
	cursor: pointer;
}
.marginprev {
	margin-left: -20px;
}
.ProgessStyle{
	padding-bottom: 4px;
	z-index: 1;
}
.heading-ellipsis {
  width: 50%;
  display:-webkit-box !important;
  -webkit-line-clamp: 1 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
::-webkit-scrollbar {
	width: 3px !important;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
.noScrollbar::-webkit-scrollbar {
  display: none;
}
:deep(.kpi-operator-select.p-select) {
  height: 31px;
  min-height: 31px;
  box-sizing: border-box;
  align-items: center;
  border-radius: 0.125rem;
}
:deep(.kpi-operator-select.p-select:not(.is-invalid)) {
  border-color: #e9e9e9 !important;
}
:deep(.kpi-operator-select.p-select.is-invalid) {
  border: 1px solid red !important;
}
:deep(.kpi-operator-select .p-select-label) {
  height: 31px !important;
  line-height: 23px !important;
  display: flex;
  align-items: center;
  padding: 4px 10px !important;
  font-size: 0.875rem !important;
  font-weight: 400 !important;
}
:deep(.kpi-operator-select .p-select-dropdown) {
  width: 2rem;
}
</style>

<script lang="ts">
import { required } from '@vuelidate/validators';
import { helpers } from '@vuelidate/validators';
const { withParams } = helpers;
// import loader from '../../components/loader.vue';
const numeric = helpers.regex('numeric', /^[0-9]+$/i);
const lessthanHundred = helpers.regex('lessthan', /^[1-9][0-9]?$|^100$/i);
const validateMetricsArray = withParams({ type: 'array' }, (value: any) => {
	return Array.isArray(value) && value.length > 0;
});
const customValidator = withParams({ type: 'array' }, validateMetricsArray);

import _ from 'lodash';
import { defineComponent } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { emitter, toast } from '@/main';
import tableData from '@/components/tableData.vue';
import breadCrumb from '@/components/breadCrumb.vue';
import popup from '@/components/popup.vue';
import pagination from '@/components/pagination.vue';
import {v4 as uuidv4 } from 'uuid';
import dotsLoader from '@/components/dotsLoader.vue';
const restrictCharacters100 = helpers.regex(/^.{0,100}$/);
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import Select from 'primevue/select';
export default defineComponent({
	props: {
		controlId: { type: [String, Number], default: null },
		from: { type: String, default: '' },
		modalMode: { type: Boolean, default: false },
	},
	emits: ['header-info', 'open-nested'],
	data(): any {
		return {
			// kpiClone: _.cloneDeep(this.addingKpiObj)	, // Deep clone the kpi object
			v$: useVuelidate(),
			showFilters: false,
			loadData:false,
			dummyList: [],
			hideFormula: false,
			addingKpiObj: {
				// kpi_id:'',
				weightage: '',
				description: '',
				target: '',
				kpiCondition: '',
				targetType: null,
			},
			dummyObj: [],
			showPopup: false,
			columnObject: false,
			controlRecurringArray: [
				{ label: 'Daily', id: 1 },
				{ label: 'Weekly', id: 2 },
				{ label: 'Monthly', id: 3 },
				{ label: 'Quarterly', id: 4 },
				{ label: 'Half-Yearly', id: 5 },
				{ label: 'Yearly', id: 6 }
			],
			kpiConditionOptions: [
				{ label: "'≥' Greater than or Equal to", value: "gte" },
				{ label: "'≤' Less than or Equal to", value: "lte" },
				{ label: "'>' Greater than", value: "gt" },
				{ label: "'<' Less than", value: "lt" },
				{ label: "'=' Equal to", value: "eq" },
			],
			targetTypeOptions: [
				{ label: "Percentage", value: "percentage" },
				{ label: "Number", value: "number" },
			],
			kpiTypeOptions:[
				{
					id:2,
					name: 'Optional'
				},
				{
					id:3,
					name: 'Custom'
				}
			],
			routesArray: [],
			saveToActiveKpis: false,

			allControls: [],
			presentControlObject: {},
			allRootKpis: [],
			kpisListForPresentControl: [],
			allRootKpisUnfiltered: [],
			carouselHead: [
				{ displayName: 'Mandatory KPIs', name: 'Kpis', id: 0 },
				{ displayName: 'Related KPIs', name: 'SuggestedKpis', id: 1 }
			],
			selecteAllActiveKpis: false,
			selecteAllRelatedKpis: false,
            checkedActiveKpis:[],
            checkedAllRelatedKpis: [],
            defaultCheckedActiveKpis:[],


			selectedTabIndex: '',
			sideButton: false,
			styling: { left: '', bottom: '' },
			pageSize: 20,
			currentPage: 1,
			dynamicPagination: '',
			currentSort: 'name',
			currentSortDir: 'asc',
			classSort: '',
			className: '',
			validtaionWeightageError: false,
			validTargetError: false,
			numberLessThanZero : false,
			targetNumberLessThanZero: false,
			filters: {},
			selectedRootKpis: [],
			titleLength: 0,
			pop: false,
			showTotalKpisWeightage: 0,
			tableHeads: ['description','weightage','target'],
			pageItems: 6,
			currentItems: 1,
			addedKpiNamesList: [],
			addedKpiNamesListExcludindSelectedKpi: [],
			isButtonDisabled: false,
			onSelectCheckBox:false
		};
	},
	components: {
		pagination,
		popup,
		breadCrumb,
		dotsLoader,
		Tabs,
        TabList,
        Tab,
        TabPanels,
        TabPanel,
		Select
	},
	validations: {
		addingKpiObj: {
			weightage: { required },
			target: { required },
			description: { required, restrictCharacters100 },
			kpiCondition: { required },
			targetType: { required }
		}
	},
	async created() {
		this.loadData = true
		await this.getAllRootKpis();
		await this.getAllActiveKpis();
		await this.getAllRootControls();
		this.loadData = false
		// await this.toggleTabs(0);
		const savedTabKey = this.modalMode ? null : sessionStorage.getItem('selectedTab');
		if (savedTabKey) {
			const savedTab = this.carouselHead.find((tab: any) => tab.id == savedTabKey);
			if (savedTab) {
			// console.log("Hiiii")
				await this.toggleTabs(savedTab.id);
			}
		} else {
			await this.toggleTabs(0);
		}
		let routeControlId = this.currentControlId;
		let controlObj;
		controlObj = this.allControls.find((item: any) => routeControlId === item._id);
		this.titleLength = controlObj?.controlTitle ? controlObj.controlTitle.length:0
		if (this.modalMode && controlObj?.controlTitle) {
			this.$emit('header-info', { title: controlObj.controlTitle });
		}
		if (this.currentFrom == 'frameworks') {
			this.routesArray = [
				{ name: 'Frameworks', routeName: 'root-Frameworks' },
				{ name: controlObj.controlNumber, routeName: 'manageRootControlMapping' }
			];
		} else if (this.currentFrom == 'internalControls') {
			this.routesArray = [
				{ name: 'Internal Controls', routeName: 'root-controls' },
				{ name: controlObj?.controlNumber, routeName: 'manageRootControlMapping' }
			];
		}
	},
  beforeUnmount() {
		if (!this.modalMode) {
			sessionStorage.removeItem('selectedTab')
		}
	},
	computed: {
		currentControlId(): any {
			return this.controlId || this.$route.params.id;
		},
		currentFrom(): any {
			return this.from || this.$route.query.from;
		},
		isDuplicateData: function (): any {
			if(this.kpisListForPresentControl.length != 0 && this.hideFormula == true){
				return {
					description: this.addedKpiNamesListExcludindSelectedKpi.some((kpi:any) =>{
						return this.addingKpiObj.description && kpi && JSON.stringify(kpi).replace(/\s+/g, '').toLowerCase() == JSON.stringify(this.addingKpiObj.description).replace(/\s+/g, '').toLowerCase()
					}),
				};
			} else if( this.hideFormula == false){
				return {
					description: this.addedKpiNamesList.some((kpi:any) =>{
						return this.addingKpiObj.description && kpi && JSON.stringify(kpi).replace(/\s+/g, '').toLowerCase() == JSON.stringify(this.addingKpiObj.description).replace(/\s+/g, '').toLowerCase()
					}),
				};
			}else {
				return false
			}
		},
		sortedData: function (): any {
			return [...this.allRootKpis]
				.filter((row: any) => {
					for (const key in this.filters) {
						const inputValue = this.filters[key];
						if (inputValue !== '' || row[key]) {
							if (Number(inputValue) && isNaN(row[key])) {
								if (!String(row[key]).includes(inputValue)) {
									return false;
								}
							} else {
								if (!row[key].toString().toLowerCase().includes(inputValue.toString().toLowerCase())) {
									return false;
								}
							}
						}
					}
					return true;
				})
				.sort((a, b) => {
					let modifier = 1;
					if (this.currentSortDir === 'desc') modifier = -1;
					if (this.currentSort === 'target' || this.currentSort === 'weightage') {
						const aNum = Number(String(a[this.currentSort] ?? '').toString().replace('%', '').trim());
						const bNum = Number(String(b[this.currentSort] ?? '').toString().replace('%', '').trim());
						const aVal = isNaN(aNum) ? Number.NEGATIVE_INFINITY : aNum;
						const bVal = isNaN(bNum) ? Number.NEGATIVE_INFINITY : bNum;
						if (aVal < bVal) return -1 * modifier;
						if (aVal > bVal) return 1 * modifier;
						return 0;
					}
					if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
					if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
					return 0;
				})
				.filter((row, index) => {
					this.dynamicPagination = index + 1;
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
		},
		sortedAppliedKpisData: function (): any {
			return [...this.kpisListForPresentControl]
				.filter((row: any) => {
					for (const key in this.filters) {
						const inputValue = this.filters[key];
						if (inputValue !== '' || row[key]) {
							if (Number(inputValue) && isNaN(row[key])) {
								if (!String(row[key]).includes(inputValue)) {
									return false;
								}
							} else {
								if (!row[key].toString().toLowerCase().includes(inputValue.toString().toLowerCase())) {
									return false;
								}
							}
						}
					}
					return true;
				})
				.sort((a, b) => {
					let modifier = 1;
					if (this.currentSortDir === 'desc') modifier = -1;
					if (this.currentSort === 'target' || this.currentSort === 'weightage') {
						const aNum = Number(String(a[this.currentSort] ?? '').toString().replace('%', '').trim());
						const bNum = Number(String(b[this.currentSort] ?? '').toString().replace('%', '').trim());
						const aVal = isNaN(aNum) ? Number.NEGATIVE_INFINITY : aNum;
						const bVal = isNaN(bNum) ? Number.NEGATIVE_INFINITY : bNum;
						if (aVal < bVal) return -1 * modifier;
						if (aVal > bVal) return 1 * modifier;
						return 0;
					}
					if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
					if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
					return 0;
				})
				.filter((row, index) => {
					this.dynamicPagination = index + 1;
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
		},
		getControlId(): any {
			return this.currentControlId;
		},
		disableStatus: function (): any {
			let output;
			if (this.editPop) {
				let objCopy = Object.assign({}, this.addingKpiObj);
				if (_.isEqual(objCopy, this.dummyObj)) {
					output = false;
				} else {
					output = true;
				}
			} else {
				if (_.isEqual(this.addingKpiObj, this.dummyObj)) {
					output = true;
				} else {
					output = false;
				}
			}
			return output;
		},
		
        arraysAreEqual: function (): any {
            const sortedArray1 = [...this.checkedActiveKpis].sort();
            const sortedArray2 = [...this.defaultCheckedActiveKpis].sort();
            
            if (sortedArray1.length !== sortedArray2.length) {
                return false;
            }

            for (let i = 0; i < sortedArray1.length; i++) {
                if (sortedArray1[i] !== sortedArray2[i]) {
                return false;
                }
            }

            return true;
        },
		cantGoBack(): any {
			return this.currentItems === 1;
		},
		cantGoForward(): any {
			return this.carouselHead.length / this.pageItems <= this.currentItems;
		},
		tabHead():any {
        const start = (this.currentItems - 1) * this.pageItems;
        const end = this.currentItems * this.pageItems;
        return this.carouselHead.slice(start, end);
       },
		// filteredTimePeriods(): any {
		// 	if (this.addingKpiObj.reportingFrequency) {
		// 		return this.controlRecurringArray.filter((value: any) => value.id >= this.addingKpiObj.reportingFrequency);
		// 	} else {
		// 		return [];
		// 	}
		// }
	},
	watch: {
		presentControlObject: {
			handler(obj: any) {
				if (this.modalMode && obj && obj.controlTitle) {
					this.$emit('header-info', { title: obj.controlTitle });
				}
			},
			deep: true,
		},
	},
	methods: {
		selectKpis(tabIndex:any , e: any){
            this.selectedRootKpis = [];
            const checked = e.target.checked;
            if (checked) {
                for (let obj of this.allRootKpis) {
                    this.selectedRootKpis.push(obj);
                }
				if (tabIndex == 1) {
					const checked = e.target.checked;
					let weightage:any = 0
					this.selectedRootKpis.map((data:any)=>{
						weightage += data.weightage
					})
					this.showTotalKpisWeightage == 0 ? (this.showTotalKpisWeightage = 0) : '';

					if (checked) {
						this.showTotalKpisWeightage = this.showTotalKpisWeightage + weightage;
					} else {
						this.showTotalKpisWeightage = this.showTotalKpisWeightage - weightage;
					}
				} else {
					this.showTotalKpisWeightage = 0;
					if(this.kpisListForPresentControl != undefined && Array.isArray(this.kpisListForPresentControl)){
						this.kpisListForPresentControl.map((obj: any) => {
							this.showTotalKpisWeightage = this.showTotalKpisWeightage + obj.weightage;
						});
					}
				}
            } else {
                this.selectedRootKpis = [];
				this.showTotalKpisWeightage = 0;
				if(this.kpisListForPresentControl != undefined && Array.isArray(this.kpisListForPresentControl)){
					this.kpisListForPresentControl.map((obj: any) => {
						this.showTotalKpisWeightage = this.showTotalKpisWeightage + obj.weightage;
					});
				}
            }
		},
		deSelectKpis(tabIndex:any , e: any){
            this.checkedActiveKpis = [];
            const checked = e.target.checked;
            if (checked) {
				this.onSelectCheckBox = !this.onSelectCheckBox;
                for (let obj of this.kpisListForPresentControl) {
                    this.checkedActiveKpis.push(obj._id);
                }
                this.selectedRootKpis = [];
				this.showTotalKpisWeightage = 0;
				if(this.kpisListForPresentControl != undefined && Array.isArray(this.kpisListForPresentControl)){
					this.kpisListForPresentControl.map((obj: any) => {
						this.showTotalKpisWeightage = this.showTotalKpisWeightage + obj.weightage;
					});
				}
            } else {
                this.checkedActiveKpis = [];
				
				if (tabIndex == 0) {
					const checked = e.target.checked;
					let weightage:any = 0
					this.selectedRootKpis.map((data:any)=>{
						weightage += data.weightage
					})
					this.showTotalKpisWeightage == 0 ? (this.showTotalKpisWeightage = 0) : '';

					if (checked) {
						this.onSelectCheckBox = !this.onSelectCheckBox;
						this.showTotalKpisWeightage = this.showTotalKpisWeightage + weightage;
					} else {
						this.onSelectCheckBox = true;
						this.showTotalKpisWeightage = 0;
					}
				} else {
					this.showTotalKpisWeightage = 0;
					if(this.kpisListForPresentControl != undefined && Array.isArray(this.kpisListForPresentControl)){
						this.kpisListForPresentControl.map((obj: any) => {
							this.showTotalKpisWeightage = this.showTotalKpisWeightage + obj.weightage;
						});
					}
				}
            }
		},

        cancelActiveKpis(){
            this.checkedActiveKpis = [...this.defaultCheckedActiveKpis];
			this.onSelectCheckBox = false;
            if(this.checkedActiveKpis.length == this.kpisListForPresentControl.length){
                this.selecteAllActiveKpis = true;
            }else{
                this.selecteAllActiveKpis = false;
            }
			if(this.kpisListForPresentControl != undefined && Array.isArray(this.kpisListForPresentControl)){
				this.kpisListForPresentControl.map((obj: any) => {
					this.showTotalKpisWeightage = this.showTotalKpisWeightage + obj.weightage;
				});
			}
        },
		cancelRelatedKpis(){
            this.selectedRootKpis = [];
            this.selecteAllRelatedKpis = false;
			this.showTotalKpisWeightage = 0;
			if(this.kpisListForPresentControl != undefined && Array.isArray(this.kpisListForPresentControl)){
				this.kpisListForPresentControl.map((obj: any) => {
					this.showTotalKpisWeightage = this.showTotalKpisWeightage + obj.weightage;
				});
			}
		},
        changedActiveControlInput(){
            if(this.checkedActiveKpis.length == this.kpisListForPresentControl.length){
                this.selecteAllActiveKpis = true;
            }else{
                 this.selecteAllActiveKpis = false;
            }
        },
		
		changedActiveKpiInput(tabIndex: any, e: any, weightage: any){

			if (tabIndex == 0) {
				const checked = e.target.checked;
				this.showTotalKpisWeightage == 0 ? (this.showTotalKpisWeightage = 0) : '';

				if (checked) {
					this.onSelectCheckBox = !this.onSelectCheckBox;
					this.showTotalKpisWeightage = this.showTotalKpisWeightage + weightage;
				} else {
					this.onSelectCheckBox = true;
					this.showTotalKpisWeightage = this.showTotalKpisWeightage - weightage;
				}
				if(this.checkedActiveKpis.length == this.kpisListForPresentControl.length){
					this.selecteAllActiveKpis = true;
				}else{
					this.selecteAllActiveKpis = false;
				}
			} else {
				this.showTotalKpisWeightage = 0;
				if(this.kpisListForPresentControl != undefined && Array.isArray(this.kpisListForPresentControl)){
					this.kpisListForPresentControl.map((obj: any) => {
						this.showTotalKpisWeightage = this.showTotalKpisWeightage + obj.weightage;
					});
				}
			}
		},

        changedRelatedKpiInput(){
            if(this.checkedAllRelatedKpis.length == this.allRootKpis.length){
                this.selecteAllRelatedKpis = true;
            }else{
                this.selecteAllRelatedKpis = false;
            }
        },


		updateSelectedFrame() {
            // Update selectedFrame based on the first tab in the current page
            this.selectedFrame = this.tabHead[0]?.name || null;
        },

		async nextPage() {
        if ((this.currentItems * this.pageItems) < this.carouselHead.length) {
            this.currentItems = this.currentItems + 1;
            this.updateSelectedTabIndex(); // Update selectedTabIndex after navigation
            this.updateCarouselClass(); // Update carousel layout after navigation
        }
		},
		async prevPage() {
			if (this.currentItems > 1) {
				this.currentItems = this.currentItems - 1;
				this.updateSelectedTabIndex(); // Update selectedTabIndex after navigation
				this.updateCarouselClass(); // Update carousel layout after navigation
			}
		},
		getColumnHeadWidth(column:any){
			if(column == 'weightage'||column == 'description'||column == 'kpiType'||column == 'target'||column == 'targetType'||column == 'kpiCondition'){
				return 'w-1/2'
			}
		},
		updateSelectedTabIndex() {
			// Update selectedTabIndex based on the first tab in the current page
			// Adjust index based on the current page and pageItems
			this.selectedTabIndex = (this.currentItems - 1) * this.pageItems;
		},
		newWeightage(kpiObj: any, previousWeightage: number = 0) {
			const totalWeightage = this.showTotalKpisWeightage - previousWeightage + kpiObj.weightage;
			return totalWeightage;
		},
		handleInput(event : any) {
			this.addingKpiObj.weightage = event.target.value.replace(/[^\d]/g, '');
		},
		handleTargetInput(event: any) {
			this.addingKpiObj.target = event.target.value.replace(/[^\d]/g, '');
		},
		getKpiConditionLabel(value: any) {
			const opt = this.kpiConditionOptions.find((item: any) => item.value === value);
			return opt ? opt.label : (value || 'N/A');
		},
		getTargetTypeLabel(value: any) {
			const opt = this.targetTypeOptions.find((item: any) => item.value === (value || 'percentage'));
			return opt ? opt.label : 'Percentage';
		},
		formatKpiTargetForDisplay(kpi: any) {
			if (kpi?.target == null || kpi.target === '') return 'N/A';
			const targetType = kpi.targetType || 'percentage';
			const numeric = Number(String(kpi.target).replace('%', '').trim());
			if (isNaN(numeric)) return 'N/A';
			if (targetType === 'number') {
				return String(numeric);
			}
			return `${numeric}%`;
		},
		weightageLessThanZero(weightage : any){
			if(weightage < 0 || weightage == 0){
				this.numberLessThanZero = true
			}else{
				this.numberLessThanZero = false
			}
		},
		weightageGreaterThanZero(kpi: any){
			if (String(kpi.weightage).includes('.')) {
				this.validtaionWeightageError = true;
				return;
			}
			this.validtaionWeightageError = false;
			let previousWeightage = 0;
			let kpiId = kpi._id;
			if (kpiId){
				const existingKpi = this.kpisListForPresentControl.find((eachKPI: any) => eachKPI._id === kpiId);
				if (existingKpi) {
					previousWeightage = existingKpi.weightage;
				}
			}
			const valid = this.newWeightage(kpi, previousWeightage);
			if (valid <= 100) {
				this.validtaionWeightageError = false;
				// this.showTotalKpisWeightage = valid;
			}else {
				this.validtaionWeightageError = true;
			}
		},
		targetLessThanZero(value: any) {
			if (value < 0) {
				this.targetNumberLessThanZero = true;
			} else {
				this.targetNumberLessThanZero = false;
			}
		},
		targetGreaterThanZero(value: any) {
			if (String(value).includes('.')) {
				this.validTargetError = true;
				return;
			}
			this.validTargetError = false;
			if (this.addingKpiObj.targetType === 'number') {
				this.validTargetError = false;
				return;
			}
			if (value <= 100) {
				this.validTargetError = false;
			} else {
				this.validTargetError = true;
			}
		},
		widthOfColumns(column:any){
			if(column == 'weightage'||column == 'kpiType'||column == 'target'||column == 'targetType'||column == 'kpiCondition'){
				return 'w-36'
			} else if(column == 'description'){
				return 'w-48'
			}
		},
		updateCarouselClass() {
				const x = window.innerWidth;
				let className = '';

				if (x > 1280) {
				className = 'page-items-7';
				this.pageItems = 7;
				} else if (x >= 1024 && x <= 1280) {
				className = 'page-items-6';
				this.pageItems = 6;
				} else if (x >= 899 && x < 1024) {
				className = 'page-items-5';
				this.pageItems = 5;
				} else if (x >= 640 && x < 899) {
				className = 'page-items-4';
				this.pageItems = 4;
				} else {
				className = 'page-items-1';
				this.pageItems = 1;
				}

				const carouselContainer = this.$refs.carouselContainer;
				if (carouselContainer) {
				carouselContainer.className = '';
				carouselContainer.classList.add(className);
				}

			// Adjust currentItems if it exceeds the number of pages
			const totalItems = this.carouselHead.length;
			const totalPages = Math.ceil(totalItems / this.pageItems);
			if (this.currentItems > totalPages) {
			this.currentItems = totalPages;
			}
			if (this.currentItems < 1) {
			this.currentItems = 1;
			}
		},
		emptyTargetTimePeriod(kpi: any) {
			if (kpi.targetTimePeriod < kpi.reportingFrequency) {
				kpi.targetTimePeriod = '';
			}
		},
		addKPI() {
			if (this.kpisListForPresentControl.length < 10) {
				let numeric = 1;
				// this.allRootKpis.forEach((item: any) => {
				// 	if (Object.keys(item).includes("kpi_id") && item.kpi_id) {
				// 		const number = item.kpi_id.split(" ");
				// 		if (parseInt(number[2]) && !isNaN(parseInt(number[2]))) {
				// 		let intNumber = parseInt(number[2]);
				// 		numeric = Math.max(numeric, intNumber);
				// 		numeric++;
				// 		}
				// 	}
				// });
				// let id = "KPI - " + numeric;
				this.addingKpiObj = { weightage: '', description: '', target: '', kpiCondition: '', targetType: null };
				// this.addingKpiObj = { kpi_id: id, weightage: '', description: '' };
				this.hideFormula = false;
				this.showPopup = true;
				this.editPop = false;
				this.dummyObj = {...this.addingKpiObj};
				
			} else {
				toast.error('Maximum KPIs should be 10', {
					timeout: 4000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
		},
		onReset() {
			// reset form validation errors
			this.v$.$reset();
			// reset form data
			const initialData = this.$options.data.call(this);
			Object.assign(this.$data, initialData);
		},
		showEditPopUp(showObj: any) {
			this.v$.$reset();
			this.showPopup = true;
			// let id = uuidv4();
			// showObj.isformula = 'A/B';
			// console.log("idid", id);
			// this.addingKpiObj.kpi_id = id;
			// this.dummyObj = _.cloneDeep();
			this.addedKpiNamesListExcludindSelectedKpi=[]
			this.kpisListForPresentControl.forEach((data:any) => {
				if(showObj._id != data._id){
					this.addedKpiNamesListExcludindSelectedKpi.push(data.description)
				}
			});
			this.editPop = true;
			this.addingKpiObj = {
				...showObj,
				kpiCondition: showObj.kpiCondition || showObj.targetOperator || showObj.logic || 'gte',
				targetType: showObj.targetType || 'percentage',
			};
			this.dummyObj = { ...this.addingKpiObj }
			this.hideFormula = true;
		},
		filterOpen() {
			if (this.columnObject == false) {
				this.showFilters = !this.showFilters;
				this.filters = {};
				emitter.emit('visible', this.showFilters);
			}
		},
		paginationUpdations(currentPage: any, pageSize: any) {
			this.currentPage = currentPage;
			this.pageSize = pageSize;
		},
		sort: function (s: any) {
			this.className = s;
			if (s === this.currentSort) {
				this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
			}
			this.currentSort = s;
			this.classSort = this.currentSortDir === 'asc' ? 'sort_asc' : 'sort_desc';
		},
		// addMetrics(kpi: { metrics: { label: string; key: string; value: string }[] }) {
		// 	this.hideFormula = true;
		// 	// this.addingKpiObj.isformula = 'A/B';
		// 	this.addingKpiObj.metrics.push({ label: '', key: 'A', value: '' });
		// 	this.addingKpiObj.metrics.push({ label: '', key: 'B', value: '' });
		// },
		onCancelbtn() {
			this.v$.$reset();
			this.validtaionWeightageError = false;
			this.validTargetError = false;
			this.numberLessThanZero = false;
			this.targetNumberLessThanZero = false;
			if (!this.addingKpiObj._id) {
				this.addingKpiObj = { weightage: '', description: '', target: '', kpiCondition: '', targetType: null };
				this.hideFormula = false;
			} else {
				this.addingKpiObj = {...this.dummyObj};
			}
		},
		async addOrUpdateKpiForControlManual(kpi: any) {
			if (this.isButtonDisabled) return;
			this.v$.$touch();
			// this.validtaionWeightageError = false;
			let check:any = !Object.values(this.isDuplicateData).includes(true)
			if (!this.v$.$invalid && this.numberLessThanZero == false && this.targetNumberLessThanZero == false && this.validtaionWeightageError == false && this.validTargetError == false && check) {
			let previousWeightage = 0;
			let kpiId = kpi._id
			this.isButtonDisabled = true;

			if (kpiId) {
			// Find the previous weightage if KPI is being updated
			const existingKpi = this.kpisListForPresentControl.find((eachKPI: any) => eachKPI._id === kpiId);
			if (existingKpi) {
				previousWeightage = existingKpi.weightage;
			}
			}

			const valid = this.newWeightage(kpi, previousWeightage);
			if (valid <= 100) {
			// this.validtaionWeightageError = false;
			kpi.weightage = Number(kpi.weightage);
			kpi.target = Number(kpi.target);
			kpi.kpiCondition = kpi.kpiCondition || 'gte';
			kpi.targetType = kpi.targetType || 'percentage';
			if (kpiId) {
				// Update the KPI
				await this.updateKpiForControl(kpi);
			} else {
				// Add new KPI
				await this.saveKpisForPresentRootControl(kpi, 'manual');
			}
			// Update showTotalKpisWeightage
			this.showTotalKpisWeightage = valid;
			this.showPopup = false;
			this.v$.$reset();
			} else {
			// this.validtaionWeightageError = true;
			}
			} 
			// else {
			// toast.error(`error`, {
			// 	timeout: 1000,
			// 	closeOnClick: true,
			// 	closeButton: "button",
			// 	icon: true,
			// });
			// }
			this.isButtonDisabled = false;
		},
		// async addOrUpdateKpiForControlManual(kpi: any) {
		// 	this.v$.$touch();
		// 	if (!this.v$.$invalid) {
		// 		if (Object.keys(kpi).includes('_id')) {
		// 			await this.updateKpiForControl(kpi);
		// 		} else {
		// 			await this.saveKpisForPresentRootControl(kpi);
		// 		}
		// 		this.showPopup = false;
		// 		this.v$.$reset();
		// 	} else {
		// 		toast.error(`error`, {
		// 			timeout: 1000,
		// 			closeOnClick: true,
		// 			closeButton: 'button',
		// 			icon: true
		// 		});
		// 	}
		// },
		async getAllRootControls() {
			this.presentControlObject = {};
			// this.kpisListForPresentControl = [];
			this.addedKpiNamesList=[]
			try {
				await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/root/controls/getall`).then((result: { data: any }) => {
					this.allControls = result.data;
					let routeControlId = this.currentControlId;
					let mainObj = result.data.find((eachItem: any) => {
						return routeControlId == eachItem._id;
					});
					if(mainObj != undefined){
						this.presentControlObject = mainObj;
					}
					// if (mainObj != undefined && Object.keys(mainObj).includes('kpis')&& Array.isArray(mainObj.kpis)) {
					// 	// this.presentControlObject = mainObj;
					// 	this.kpisListForPresentControl = mainObj.kpis;

					// 	let mappedKpis: any = [];
					// 	if(this.kpisListForPresentControl != undefined){
					// 		this.kpisListForPresentControl.map((obj: any) => {
					// 			mappedKpis.push(obj.description);
					// 			this.addedKpiNamesList.push(obj.description)
					// 		});
					// 	}

					// 	if (mappedKpis.length > 0) {
					// 		let filteredRootKpis = this.allRootKpis.filter((obj: any) => {
					// 			return !mappedKpis.includes(obj.description);
					// 		});
					// 		this.allRootKpis = filteredRootKpis;
					// 	}
					// } else {
					// 	this.kpisListForPresentControl = [];
					// }
				});
			} catch (e) {
				toast.error('error', {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
		},
		async getAllActiveKpis(){
			// /api/root/control/:controlId/active/kpis/get
			this.kpisListForPresentControl = []
			this.checkedActiveKpis = []
			this.defaultCheckedActiveKpis = []
			let dummy:any = []
			let controlId:any = this.currentControlId
			try {
				await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/root/control/${controlId}/active/kpis/get`).then((result: { data: any }) => {
					dummy = result.data
				});
				let mappedKpis: any = [];
				dummy.map((obj: any) => {
					mappedKpis.push(obj.description);
					this.addedKpiNamesList.push(obj.description)
					this.checkedActiveKpis.push(obj._id)
					this.defaultCheckedActiveKpis.push(obj._id);
				});
				if (mappedKpis.length > 0) {
					let filteredRootKpis = this.allRootKpis.filter((obj: any) => {
						return !mappedKpis.includes(obj.description);
					});
					this.allRootKpis = filteredRootKpis;
				}
				
				this.kpisListForPresentControl = [...dummy]
						
				if(this.checkedActiveKpis.length == this.kpisListForPresentControl.length && this.kpisListForPresentControl.length!=0){
					this.selecteAllActiveKpis = true;
				}else{
					this.selecteAllActiveKpis = false;
				}
			} catch (e) {
				toast.error('error', {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
		},
		doFalse() {
			this.pop = false;
		},
		async getAllRootKpis() {
			this.allRootKpis = [];
			this.allRootKpisUnfiltered = [];
			let controlId:any = this.currentControlId
			try {
				await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/root/control/${controlId}/kpis/getall`).then((result: { data: any }) => {
					this.allRootKpisUnfiltered = [...result.data];
					this.allRootKpis = result.data;
				});
			} catch (e) {
				toast.error('error', {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
		},
		async toggleTabs(navIndex: any) {
			this.selectedTabIndex = navIndex;
			this.calculateWeightAge(0);
			this.selectedRootKpis = [];
			this.showFilters = false;
			this.filters = {};
			sessionStorage.setItem('selectedTab', navIndex);

			if (navIndex == 0) {
                this.currentPage = 1
                // this.filtersOpen();
                // emitter.emit('visible', false);
                // this.showFilters = false;
				this.loadData = true
                await this.getAllRootKpis();
                await this.getAllActiveKpis();
				this.loadData = false
            } else if (navIndex == 1) {
                this.currentPage = 1
				this.selecteAllRelatedKpis = false
                // this.filtersOpen();
                // emitter.emit('visible', false);
                // this.showFilters = false;
				this.loadData = true
                await this.getAllRootKpis();
                await this.getAllActiveKpis();
				this.loadData = false
            }
		},
		async saveKpisForPresentRootControl(kpiObj: any) {
			let finalArr: any[] = [];
			let routeControlId = this.currentControlId;
			let controlObj;
			controlObj = this.allControls.find((item: any) => routeControlId === item._id);
			if (this.showTotalKpisWeightage <= 100) {
				if (this.selectedTabIndex == 1) {
					this.selectedRootKpis.map((obj: any) => {
						obj.referenceKpiId = obj._id;
						delete obj._id;
						finalArr.push(obj);
					});
				} else {
					// kpiObj._id = this.$route.params.id;
					kpiObj.kpi_id=""
					finalArr.push(kpiObj);
				}
				let controlPayLoadFramework;
				if (this.currentFrom == 'frameworks') {
					controlPayLoadFramework = controlObj.controlFrameWork;
				} else if (this.currentFrom == 'internalControls') {
					controlPayLoadFramework = 'InternalControls';
				}
				let controlId:any = this.currentControlId
				this.isButtonDisabled = true;
				try{
					await this.$http.post(`${process.env.VUE_APP_CONTROLS_API}/api/root/control/${this.currentControlId}/kpis/add?frameWork=${controlPayLoadFramework}`, finalArr).then(async () => {
					toast.info('Saved Successfully', {
						timeout: 5000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
					this.selectedRootKpis = [];
					await this.getAllRootControls();
					await this.toggleTabs(0);
				});
				}
				catch(e){
					toast.info('Error', {
						timeout: 5000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
				}
				finally{					
					this.isButtonDisabled = false;
				}
				// /api/root/control/${this.$route.params.id}/kpis/add?frameWork=${controlPayLoadFramework}`
			} else {
				toast.error('Total Weightage should be less than 100', {
					timeout: 5000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
		},
		calculateWeightAge(tabIndex: any, e: any, weightage: any) {
			if (tabIndex == 1) {
				const checked = e.target.checked;
				this.showTotalKpisWeightage == 0 ? (this.showTotalKpisWeightage = 0) : '';

				if (checked) {
					this.showTotalKpisWeightage = this.showTotalKpisWeightage + weightage;
				} else {
					this.showTotalKpisWeightage = this.showTotalKpisWeightage - weightage;
				}
				if(this.selectedRootKpis.length == this.allRootKpis.length){
					this.selecteAllRelatedKpis = true;
				}else{
					this.selecteAllRelatedKpis = false;
				}
				// this.selectedRootKpis.map((obj:any)=>{this.showTotalKpisWeightage = this.showTotalKpisWeightage + obj.weightage})
			} else {
				this.showTotalKpisWeightage = 0;
				if(this.kpisListForPresentControl != undefined && Array.isArray(this.kpisListForPresentControl)){
					this.kpisListForPresentControl.map((obj: any) => {
						this.showTotalKpisWeightage = this.showTotalKpisWeightage + obj.weightage;
					});
				}
			}
		},
		async updateKpiForControl(kpiObj: any) {
			let routeControlId = this.currentControlId;
			let controlObj;
			controlObj = this.allControls.find((item: any) => routeControlId === item._id);
			let kpiId = kpiObj._id;
			delete kpiObj._id;
			let controlPayLoadFramework;
			if (this.currentFrom == 'frameworks') {
				controlPayLoadFramework = controlObj.controlFrameWork;
			} else if (this.currentFrom == 'internalControls') {
				controlPayLoadFramework = 'InternalControls';
			}
			await this.$http.post(`${process.env.VUE_APP_CONTROLS_API}/api/root/control/${routeControlId}/kpi/${kpiId}/update?frameWork=${controlPayLoadFramework}`, kpiObj).then(async () => {
				toast.info('Updated Successfully', {
					timeout: 5000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
				this.selectedRootKpis = [];
				await this.getAllRootControls();
				await this.toggleTabs(0);
				this.showPopup = false;
			});
		},

		async saveToRelatedKpis(obj:any,type:any){
			// /api/root/control/:controlId/kpis/:type
			// note:if you are selecting an kpi from relative kpi then type is 10301, if you select kpi from active kpis then the type is 10303
			let controlId:any = this.currentControlId
			let payload:any = []
			this.isButtonDisabled = true;
			this.selectedRootKpis = [];

			if(this.showTotalKpisWeightage <= 100){
				if(type == 10301){
					if(obj !=undefined){
						obj.map((data:any)=>{
							// let keysOfdata:any = Object.keys(data)
							// if(keysOfdata.includes('kpiType') && data.kpiType == 3){
							// 	payload.push(data)
							// } else {
								let payloadObj:any = {
									kpi_id: data.kpi_id,
									weightage: data.weightage,
									description: data.description,
									target: data.target != null && data.target !== '' ? Number(data.target) : data.target,
									kpiCondition: data.kpiCondition || data.targetOperator || data.logic || 'gte',
									targetType: data.targetType || 'percentage',
									referenceKpiId: data._id
								}
								// console.log("jgsdsdhsdjhs",data)
								payload.push(payloadObj)
							// }
						})
						// payload = obj
					}
				}else if(type == 10303){
					let deselectedControls:any = this.defaultCheckedActiveKpis.filter((id:any) => !this.checkedActiveKpis.includes(id));
					if(deselectedControls != undefined && deselectedControls.length != 0){
						this.kpisListForPresentControl.forEach((kpiData:any) => {
							deselectedControls.map((data:any)=>{
								if(data == kpiData._id){
									delete kpiData._id;
									payload.push(kpiData)
								}
							})
						});
					}
					// payload = deselectedControls
				}
				let controlPayLoadFramework:any
				let controlObj:any
				let routeControlId = this.currentControlId;
				controlObj = this.allControls.find((item: any) => routeControlId === item._id);
				if (this.currentFrom == 'frameworks') {
					controlPayLoadFramework = controlObj.controlFrameWork;
				} else if (this.currentFrom == 'internalControls') {
					controlPayLoadFramework = 'InternalControls';
				}
				try {
					await this.$http.post(`${process.env.VUE_APP_CONTROLS_API}/api/root/control/${controlId}/kpis/${type}?frameWork=${controlPayLoadFramework}`,payload).then(async (result: { data: any }) => {
						
						toast.info('Updated Sucessfully', {
							timeout: 1000,
							closeOnClick: true,
							closeButton: 'button',
							icon: true
						});
						await this.getAllActiveKpis();
						await this.getAllRootKpis();
						this.onSelectCheckBox = false;
					});
				} catch (e) {
					toast.error('error', {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
				}finally {
					this.isButtonDisabled = false;
				}
			} else {
				this.showTotalKpisWeightage = 0;
				this.selecteAllRelatedKpis = false;
				if(this.kpisListForPresentControl != undefined && Array.isArray(this.kpisListForPresentControl)){
					this.kpisListForPresentControl.map((obj: any) => {
						this.showTotalKpisWeightage = this.showTotalKpisWeightage + obj.weightage;
					});
				}			
				toast.error('Total Weightage should be less than 100', {
					timeout: 5000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
			setTimeout(() => {
				this.isButtonDisabled = false;
			}, 5000);
		}
	},
	mounted() {
		window.addEventListener('resize', this.updateCarouselClass);
		this.updateCarouselClass(); 
	},
});
</script>